var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-container",class:{ reverse: _vm.reverse }},[_vm._t("left"),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }